module.exports = __webpack_public_path__ + "static/img/head-logo.331a8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/library/head-logo.png
// module id = Rfqe
// module chunks = 0 2